import React from "react";
import PageHeader from "./components/PagesHeaderComponent/PageHeader";
import { Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom/dist";

const MyApplication = () => {

	const navigate = useNavigate();
	const data = [
		{
			title: "Nolan Miller",
			subTitle: "Associate Professor of Finance"
		},


	]


	return (
		<>
			<PageHeader heading="My Application" />
			<div className="content_wrap">
				<div className="myApplication">
					{/* <section className='sec sec2'> */}

					<div className='container'>
						{data.map((e) => {
							return <>
								<Card>
									<div className="wrap_application">
										<div>
											<h4 className="bold">{e.title}</h4>
											<h6>{e.subTitle}</h6>
										</div>
										<button className="rounded_btn" variant="primary">Rejected</button>
									</div>
								</Card>
							</>
						})}

					</div>
				</div>
			</div>
		</>
	);
};

export default MyApplication;
